import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App" style={{ height: '100vh', width: '100%' }}>
      <iframe
        src="/TE_Certificate.pdf"
        title="TE Certificate"
        width="100%"
        height="90%"
        style={{ border: 'none' }}
      />
    </div>
  );
}

export default App;